// removed by extract-text-webpack-plugin
module.exports = {"root":"_32FGl"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/breadcrumbTheme.scss
// module id = 1190
// module chunks = 2